import {
  AppBar,
  Box,
  Grid,
} from '@mui/material';

import { landingMainContainerStyle } from './ladingMainContainerStyle';

import desktopBackground from '../../../../assets/desktopBackground.png';
import logoMobile from '../../../../assets/logoMobile.png';
import { useDesktopMediaQuery } from '../../../../hooks/useDesktopMediaQuery';

export interface ObjectType {
  [key: string]: any;
}

interface LandingContainerProps {
  children: JSX.Element | JSX.Element[]
}

export const LandingMainContainer = ({ children }: LandingContainerProps) => {
  const { matchesMD } = useDesktopMediaQuery();
  return (
    <Grid
      container
      style={
        matchesMD
          ? landingMainContainerStyle.mainContainerDesktop
          : landingMainContainerStyle.mainContainerMobile
      }
    >
      {
        matchesMD
          ? (
            <>
              <Grid
                item
                md={5}
                style={landingMainContainerStyle.maxHeigthPercentage}
              >
                <Box
                  component="img"
                  src={desktopBackground}
                  style={landingMainContainerStyle.imageContainer}
                />
              </Grid>
              <Grid
                item
                md={7}
                style={landingMainContainerStyle.maxHeigthPercentage}
              >
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={landingMainContainerStyle.maxHeightVH}
                >
                  <Grid
                    item
                    alignItems="center"
                    justifyContent="center"
                    md={9}
                    style={landingMainContainerStyle.maxHeigthPercentage}
                  >
                    {children}
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            <>
              <AppBar
                position="fixed"
                sx={landingMainContainerStyle.appbarContainer}
              >
                <Box
                  component="img"
                  alt="Santa Lucia Logo"
                  src={logoMobile}
                  sx={landingMainContainerStyle.appbarLogo}
                />
              </AppBar>
              <Grid
                item
                xs={12}
                style={landingMainContainerStyle.containerWithAppbar}
              >
                <Grid
                  container
                  justifyContent="center"
                  alignItems="start"
                  padding={1.3}
                  style={landingMainContainerStyle.maxHeigthPercentage}
                >
                  <Grid
                    item
                    justifyContent="center"
                    xs={12}
                    style={landingMainContainerStyle.maxHeigthPercentage}
                  >
                    {children}
                  </Grid>
                </Grid>
              </Grid>
            </>
          )
      }
    </Grid>
  );
};
